import { Injectable } from '@angular/core';
import { SimuladorGoApi } from '@gestor-web/@core/api/go';
import { map } from 'rxjs/operators';

@Injectable()
export class CnesGenericoIncompativelService {
  constructor(private simuladorGoApi: SimuladorGoApi) {}

  getGuiasCnesGenerico(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchGuiasCnesGenerico({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(map(data => data.items ?? []));
  }

  getGuiasCnesIncompativel(regans: string, competenciaInicial: string, competenciaFinal: string) {
    return this.simuladorGoApi
      .fetchGuiasCnesIncompativel({
        regans,
        competencia: competenciaInicial,
        competencia_final: competenciaFinal,
      })
      .pipe(map(data => data.items ?? []));
  }

  getUltimoProcessamento(regans: string) {
    return this.simuladorGoApi
      .fetchCnesGenericoIncompativelUltimoProcessamento({ regans })
      .pipe(map(data => data.items?.[0]?.dt_atualizacao_mon_guia ?? null));
  }
}
